import { RouteEntry } from "../../shared/routes";
import { Certificate } from "./Certificate";

export const certificateRoutes: Array<RouteEntry> = [
    { path: '/certificate/:schoolId', exact: true, component: Certificate, authorize: false, }, // Anyone can check the certificate for a school and it is linked from their web badge.
];
